import OrganizationActionTypes, * as actionDicts from "shared/profiles/organization/organization-profile-action-types"
import { resourceGetDetail, sendAction } from "shared/djangio/action-creators"
import { loadDataDescription } from "shared/state_management/action-creators"
import { loadCustomFields } from "shared/customFields/action-creators"
import { loadSocialUsersFromOrganization } from "shared/social/social-user-action-creators"
import { attachActionHandlers } from "shared/profiles/constants/helperFunctions"

const { PublicOrganization } = DjangIO.app.person.models

export const loadOrganization = (id) =>
    resourceGetDetail(
        PublicOrganization.objects.filter({
            dehydrate_extra: ["beats", "market_areas", "social_users"],
        }),
        actionDicts.loadOrganizationActionDict,
        id,
        { id },
    )

export const loadData =
    (id, handlers = {}) =>
    (dispatch, getState) => {
        const pubOrg = getState().organizationProfile.toJS().organizations[id]
        if (
            !pubOrg ||
            // or if the id is there but the organization has not been loaded
            (pubOrg && !pubOrg.organization)
        ) {
            dispatch(
                attachActionHandlers({
                    loadActionCreator: loadOrganization,
                    profileId: id,
                    handlers,
                }),
            )
            dispatch(
                loadDataDescription({
                    qdt: DjangIO.app.models.QuorumDataType.public_organization,
                    id,
                }),
            )
            dispatch(loadCustomFields(Userdata.organization_id))
            return dispatch(loadSocialUsersFromOrganization(id))
        }
        if (handlers.successHandler) {
            return dispatch(handlers.successHandler(pubOrg))
        }
    }

export const updateCustomTagDict = (newTagDictValues) => ({
    type: OrganizationActionTypes.UPDATE_ORGANIZATION_TAG_DICT,
    newTagDictValues,
})

export const invalidateOrg = (id) => ({
    type: OrganizationActionTypes.INVALIDATE_ORGANIZATION,
    id,
})

/**
 * Action creator used for fetching transaction summary data for the current Public Organization profile.
 * The kwargs must include a list for public_organization and a ledger settings id.
 * All years that have transaction activity will be fetched.
 *
 * @param {Number} ledgerSettingsId - current ledger settings
 * @param {Number} id - Public Organization id
 */
export const loadOrganizationSummary = (id, ledgerSettingsIds) =>
    sendAction(DjangIO.app.ledger.models.Transaction, actionDicts.loadOrganizationTransactionSummaryActionDict, {
        action: "transactions_summary",
        method: "get",
        kwargs: {
            public_organization: [id],
            ledger_settings: ledgerSettingsIds,
            transaction_type: [DjangIO.app.ledger.types.TransactionType.money_received.value],
        },
        payload: {
            id,
        },
    })
